import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeclarationPromptComponent } from './declaration-prompt.component';
import { DeclarationDraftNoticeComponent } from './declaration-draft-notice.component';

@NgModule({
  declarations: [
    DeclarationPromptComponent,
    DeclarationDraftNoticeComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [DeclarationPromptComponent, DeclarationDraftNoticeComponent]
})
export class DeclarationPromptModule { }
